import { render } from "./PbMajor.vue?vue&type=template&id=474080ee"
import script from "./PbMajor.vue?vue&type=script&lang=js"
export * from "./PbMajor.vue?vue&type=script&lang=js"

import exportComponent from "D:\\newProjectGit\\HbzsbAdminClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__